import { Box, Button } from '@mui/material';
import { actionButtonsStyles } from './styles';

type RecordingState =
  | 'idle'
  | 'recording'
  | 'paused'
  | 'stopped'
  | 'processing';

interface ActionButtonsProps {
  recordingState: RecordingState;
  recordedBlob: Blob | null;
  isProcessingAudio: boolean;
  hasRecordingBlob: boolean; // Add this to check if we have any recording
  onCreateAINote: () => void;
  onRecordNew: () => void;
  allowParallelRecording?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  recordingState,
  recordedBlob,
  isProcessingAudio,
  hasRecordingBlob,
  onCreateAINote,
  onRecordNew,
  allowParallelRecording = false,
}) => {
  return (
    <Box sx={actionButtonsStyles.container}>
      <Button
        variant="contained"
        onClick={onCreateAINote}
        disabled={
          (!recordedBlob && !hasRecordingBlob) || recordingState === 'processing' || isProcessingAudio
        }
        sx={actionButtonsStyles.getNoteButton}
      >
        {recordingState === 'processing' ? 'Processing...' : 'Get Note'}
      </Button>

      <Button
        variant="outlined"
        onClick={onRecordNew}
        disabled={(recordingState === 'processing' || isProcessingAudio) && !allowParallelRecording}
        sx={actionButtonsStyles.recordNewButton}
      >
        Record New
      </Button>
    </Box>
  );
};

export { ActionButtons };
